export default "__VITE_ASSET__hFzEQ5aT__"